var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSignArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_6983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3H13C13.5531 3 14 3.44688 14 4V12C14 12.5531 13.5531 13 13 13H11C10.4469 13 10 13.4469 10 14C10 14.5531 10.4469 15 11 15H13C14.6562 15 16 13.6562 16 12V4C16 2.34375 14.6562 1 13 1H11C10.4469 1 10 1.44687 10 2C10 2.55313 10.4469 3 11 3ZM10.7063 8.70625C11.0969 8.31563 11.0969 7.68125 10.7063 7.29063L6.70625 3.29063C6.31563 2.9 5.68125 2.9 5.29063 3.29063C4.9 3.68125 4.9 4.31563 5.29063 4.70625L7.58437 7H1C0.446875 7 0 7.44688 0 8C0 8.55312 0.446875 9 1 9H7.58437L5.29063 11.2937C4.9 11.6844 4.9 12.3188 5.29063 12.7094C5.68125 13.1 6.31563 13.1 6.70625 12.7094L10.7063 8.70938V8.70625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_6983"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignArrow);
export default __webpack_public_path__ + "static/media/ic_sign_arrow.362457af309e2e85238667578c41932e.svg";
export { ForwardRef as ReactComponent };